<template>
  <page-view>
    <a-card class="mb-3">
      <a-form-model class="exi_form v2"
                    ref="form" :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
        <a-form-model-item label='综合查询' style="width: 600px">
          <a-input v-model="queryForm.projectQuery" placeholder="招标编号|项目名称"/>
        </a-form-model-item>
        <a-form-item label='专家名称' style="width: 600px">
          <a-input v-model="queryForm.expertName" placeholder="专家名称"/>
        </a-form-item>
        <a-button type="primary" icon="search" @click="onSearch">查询</a-button>
        <a-button type="primary" @click="refresh">重置</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table :rowKey="(record) => record.extractId" ref="table" :columns="columns"
               :pagination="{showTotal: (total) => `共 ${total} 条`}" :data="loadData">
        <template v-slot:detail="text">
          <a @click="showDetail(text.extractId)">查看</a>
        </template>
      </s-table>
    </a-card>
    <a-modal
        title="推送详情"
        :visible="visible"
        @ok="visible = false"
        @cancel="visible = false"
        width="1200px"
        :footer="null"
    >
      <div class="detail">
        <a-skeleton active v-if="spinning"/>
        <div v-else style="background-color: #ececec; padding: 10px;">
          <a-row :gutter="16">
            <a-col :span="12" v-for="item in Object.keys(detailList) ">
              <a-card v-if="typeArr.includes(item)" :title="getCardTile(item)" class="mt-2"
                      :bordered="false" v-for="item2 in detailList[item]">
                <template slot="extra">资源类型: {{ item2.resourceType }}</template>
                <div :key="item2.id">
                  <a-descriptions :title="item2.actionType">
                    <a-descriptions-item label="时间">
                      {{ item2.createTime | dayjs('YYYY-MM-DD HH:mm') }}
                    </a-descriptions-item>
                    <a-descriptions-item label="refId">
                      {{ item2.refId }}
                    </a-descriptions-item>
                  </a-descriptions>
                  <highlightjs
                      language='json'
                      :code="jsonBeautify(JSON.parse(item2.content), null, 2, 80)"
                  />
                </div>
              </a-card>
            </a-col>
          </a-row>
        </div>

      </div>
    </a-modal>
  </page-view>
</template>

<script>
import PageView from '@/layouts/PageView'
import STable from '@/components/Table'
import jsonBeautify from 'json-beautify'
import { ListByRefId, QueryDyVmsPushLogVoList } from '@/epp/ivrlog/api/LogApi'
import moment from 'moment'

export default {
  name: 'IvrPushLog',
  components: {
    PageView,
    STable
  },
  data () {
    return {
      jsonBeautify,
      visible: false,
      spinning: false,
      detailList: {},
      detailPushList: [],
      detailRePortList: [],
      queryForm: {
        projectQuery: undefined,
        expertName: undefined,
        callState: undefined,
      },
      typeArr: [
        'DY_VMS_IVR_CALL',
        'DY_VMS_IVR_VOICE_REPORT'
      ]
    }
  },
  computed: {
    getCardTile () {
      return function (type) {
        switch (type) {
          case this.typeArr[0]:
            return '语音呼叫'
          case this.typeArr[1]:
            return '语音消息回执'
        }
      }
    },

    columns () {
      return [
        {
          title: '项目名称',
          dataIndex: 'projectName'
        },
        {
          title: '项目编号',
          width: '250px',
          dataIndex: 'projectCode'
        },
        {
          title: '开标时间',
          width: 200,
          dataIndex: 'openDate',
          customRender: (text) => {
            return text && moment(text).format('YYYY年MM月DD日 HH:mm')
          }
        },
        {
          title: '专家名称',
          width: 160,
          dataIndex: 'expertName'
        },
        {
          title: '抽取时间',
          width: 200,
          dataIndex: 'addDate',
          customRender: (text) => {
            return text && moment(text).format('YYYY年MM月DD日 HH:mm')
          }
        },
        {
          title: '推送结果',
          dataIndex: 'callState',
          width: 200
        },
        {
          title: '操作',
          width: 200,
          scopedSlots: { customRender: 'detail' }
        }
      ]
    }
  },
  watch: {},
  methods: {
    loadData (parameter) {
      const params = { ...parameter, ...this.queryForm }
      return QueryDyVmsPushLogVoList(params)
    },
    refresh () {
      this.queryForm = {}
      this.onSearch()
    },
    onSearch () {
      this.$refs.table.refresh(true)
    },
    async showDetail (id, type) {
      this.visible = true
      this.spinning = true
      const res = await ListByRefId(id, type)
      this.detailList = { ...res.result }
      this.spinning = false
    }
  }
}
</script>

<style scoped>

.detail:empty::after {
  color: #D1D5DB;
  content: '无详情';
}
</style>
